// function data(){
//     return {

//     }
// }

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  // base_url: "http://20.189.127.73:3004/"
  base_url: "http://api.evanmandery.com/",
};
